import React,{useState,useEffect,useCallback} from 'react';
import {RouteComponentProps, Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
//import {Styles} from './Styles';
import Header from './Header';
import Tweet from './Tweet';
import Loading from './Loading';
import Ajax from './Ajax';


interface RCProps extends RouteComponentProps<{gid?:string}> {
	
}

interface Props {
    uid:string,
}

let gid:string;

const Enter = (props:Props)=> {
    //const classes = Styles.base();
    const [isRedirect,setIsRedirect] = useState(false);
    const [play,setPlay] = useState();

    const rcp:RCProps = useReactRouter();
	if( rcp.match.params.gid ){
		gid = rcp.match.params.gid;
	} else {
		gid = "";
	}

    const load = useCallback(()=>{
        Ajax.send("play/result",{gid:gid},(res:any)=>{
            if( res.ok ){
                setPlay(res.play);
            } else {
                setIsRedirect(true);
            }
        })
    },[]);

    const close = ()=>{
        setIsRedirect(true);
    }

    useEffect( ()=>{
        load();
    },[load]);

    if(!play){
        return (
            <Loading isLoading={true}/>
        )
    }

    if( isRedirect ){
        return (
            <Redirect to="/"/>
        );
    }

	return (
        <div id="enter">
            <Header top={close}/>
            <Tweet play={play} end={close} uid={props.uid}/>
        </div>
    );
}

export default Enter;
